<template>
  <div class="agreement-container">
    <van-nav-bar
      :title="locale == 'zh' ? '協議' : 'Agreement'"
      left-text="返回"
      left-arrow
    >
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div
      style="min-height: 100%; padding: 1.6rem; background: rgb(255, 255, 255)"
    >
      <div>
        <p>
          <img
            style="width: 100%"
            src="data:image/png;base64,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"
            alt=""
          />
        </p>
        <h1 style="font-size: 18px; text-align: center">
          Loan agreement and guarantee
        </h1>
        <div style="margin: 30px 0; border-bottom: 1px dashed #333">&nbsp;</div>
        <div style="font-size: 14px">&nbsp;</div>
        <div style="border: 1px dashed #333">
          <div
            style="
              line-height: 50px;
              font-size: 18px;
              font-weight: 600;
              text-align: center;
            "
          >
            Content contract
          </div>
          <div
            style="
              background: #000;
              color: #fff;
              font-weight: 600;
              padding: 10px;
            "
          >
            Subject: Your
            <span style="flex: 1; padding: 5px 10px; position: relative"
              ><span class="r-period">{{ period }}</span></span
            >
            monthly cash loan application for FINANCIAL COMPANY
          </div>
          <div style="padding: 10px">
            Thank you for choosing NOW FINANCIAL COMPANY as your unsecured
            personal loan company. We would like to inform you that in
            accordance with the above requirements, we approve your loan in
            principle as follows:
          </div>
        </div>
        <ul style="padding: 0; border: 1px solid #333; margin-top: 20px">
          <li style="display: flex; margin-bottom: 1px">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >Loan Type</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              >Installment Loan<br /><em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
          <li style="display: flex; margin-bottom: 1px">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >Loan term</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              ><span class="r-period">{{ period }}</span> month<em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
          <li style="display: flex; margin-bottom: 1px">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >loan amount</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              ><span class="r-loanAmount">{{ amount }}</span>
              <span class="r-currency">USDT</span><br /><em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
          <li style="display: flex; margin-bottom: 1px">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >Hobby type</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              >Permanent<br /><em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
          <li style="display: flex; margin-bottom: 1px">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >Interest rate</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              ><span class="r-loanRate">{{ (rate * 100).toFixed(4) }}</span
              >% /1month<em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
          <li style="display: flex; margin-bottom: 1px">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >Effect of Sanction Letter</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              >Effective within 1 month from the date of issue of Sanction
              Letter<br /><em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
          <li style="display: flex; margin-bottom: 0">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >Verify private cryptocurrency address (gas fee)</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              >First, there are no fees to pay for a loan! However, when
              verifying the crypto address, a gas fee of about 1-10 USDT will be
              generated.<br /><em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
        </ul>
        <ul style="padding: 0; border: 1px solid #333">
          <li style="display: flex; margin-bottom: 1px">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >All applicable taxes, fees and duties will be charged as required
              by law.</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              >Processing fees and applicable fees will be charged prior to loan
              disbursement. The total amount of interest will be amortized over
              the term of the loan.<br /><br /><em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
          <li style="display: flex; margin-bottom: 0">
            <span
              style="
                flex: 1;
                padding: 5px 10px;
                position: relative;
                color: #fff;
                background: #333;
              "
              >Observe. Subject to the terms and conditions, deferred interest
              will be charged at {{ Number(rate * 100).toFixed(4) }}% per month
              ({{ totalRate.toFixed(4) }}% per annum) from the due date of the
              installment.</span
            ><span style="flex: 1; padding: 5px 10px; position: relative"
              >Special conditions: Your loan has been pre-approved by the NOW
              FINANCE Group Pty Ltd In some cases, our partner Crypto Wallet
              and&nbsp; banks will perform a special check on your credit check
              and charge an additional fee.<br /><br /><em
                style="
                  position: absolute;
                  height: 1px;
                  background: #333;
                  width: 100%;
                  left: 0;
                  bottom: -1px;
                "
                >&nbsp;</em
              ></span
            >
          </li>
        </ul>
        <div style="padding: 10px; border: 1px solid #333">
          After accepting the above terms, we will pay the amount #to be paid
          directly to the salary Beneficiary address&nbsp;you provided when
          applying for the loan.
        </div>
        <div style="margin-top: 20px">
          <p>
            1.Borrower, the name and the signatory on the front of this
            Agreement (hereinafter referred to as "the Borrower") undertake to
            the Company (hereinafter referred to as the "Lender") that the
            Borrower agrees to abide by the terms and conditions of this
            Agreement. terms and conditions of this Agreement. The following
            terms and conditions
          </p>
          <p>
            1) The Universal Revolving Credit Agreement ("Agreement") shall be
            in full force and effect in accordance with the Lender's Universal
            Revolving Credit Agreement ("Terms"). Credit contracts and revolving
            applications typically require the contracting parties to provide
            credit after approval by the company. (hereinafter referred to as
            "Customer") in contracts and applications for revolving credit in
            general. (hereinafter referred to as the "Request/Agreement")
          </p>
          <p>
            2) The company will decide whether to accept the credit line or not.
            Once the company approves the customer's credit application, the
            company will notify the customer of their credit line by mail,
            telephone or any other approved means.
          </p>
          <p>2. Loan agreement and conditions</p>
          <p>
            1. According to the analysis results of the blockchain and bank, the
            company will consider risks when granting credit lines to borrowers.
            The borrower must agree to a financial liquidity check. The company
            checks the borrower's minimum solvency, about 20% to 50% of the loan
            amount (depending on the credit bureau's review). application), to
            create a credit history for personal loan installments
          </p>
          <p>
            2. Borrower warrants that the loan will not be used for illegal
            purposes without reason
          </p>
          <p>3. Liability to terminate the contract</p>
          <p>
            (1)After this agreement is signed (if not submitted for review, it
            will be deemed invalid), both parties must comply with all terms of
            this agreement. If one party violates the terms of the contract, the
            other party has the right to sue in the relevant court. In case the
            borrower is unable to disburse the loan due to personal reasons, the
            borrower needs to file an application for disbursement of the loan.
            Borrowing at the request of the Blockchain Financial Center and the
            party violating the contract must pay a penalty of 50% of the loan
            amount, the two parties have no objection.
          </p>
          <p>
            (2) The borrower must ensure that the loan amount is not used for
            illegal purposes prohibited by the state
          </p>
          <p>
            (3) The borrower must repay the loan on time as agreed in the
            contract. If the borrower wants to extend the loan, they must apply
            to the lender 5 days before the loan expires. If the borrower wants
            to repay the loan before the due date, the application must be
            submitted to the lender 5 days before the next repayment period
          </p>
          <p>
            4. Once a borrower is approved for a loan, for some qualified
            customers with a poor credit record, the lender needs to verify
            their identity first and the borrower needs to submit twenty to
            fifty parts When a credit score is insufficient, borrowers are
            required to submit a follow-up payment for review, and borrowers who
            are unable to pay by direct debit should contact customer service to
            finalize the payment first. Only after the borrower makes the first
            payment can the borrower be verified for disbursement.
          </p>
          <p>
            5.If the borrower fails to perform the contract, the borrower
            undertakes to bear the damage caused by the lender. It allows the
            borrower to determine all costs incurred, including litigation and
            attorney fees, reimbursement of attorneys' fees and other costs that
            need to be paid, based on the borrower's evidence. The borrower
            replies that the lender has read and understood the contract
            documents
          </p>
          <p>
            6.According to regulations of the Australia financial system,
            borrowers need to verify the individual's minimum repayment ability.
            When a borrower's credit score is problematic, it is necessary to
            coordinate with the credit investigation department of the
            Blockchain Financial Center and national bank to complete a personal
            credit score to verify the disbursement, half an hour after
            approval, the Blockchain Financial Center The customer will transfer
            the money to the account specified in the borrower's contract. If
            the borrower does not comply with the terms of the contract after
            the contract is signed, it will be considered a serious fraud and
            will be prosecuted and punished by the Australia courts according to
            the law.
          </p>
          <p>
            7. Both parties have the right to terminate their obligations under
            this agreement. In case one party terminates the contract but still
            owes the other party full compensation, it must notify the other
            party in writing at least 7 working days in advance. And the party
            who terminates the contract must pay a penalty of 50% of the credit
            limit. The parties must immediately begin to enforce the purpose of
            this agreement to obtain legal protection
          </p>
          <p>
            8. Guarantee conditions: FINANCIAL COMPANY and NATIONAL BANK jointly
            issue the loan. During the loan period, the borrower must ① pay
            interest on time - pay principal on time ② meet and comply with all
            terms of the contract. If the above points are violated, the
            borrower will have a bad personal credit history created by the
            bank's credit system.
          </p>
        </div>
        <h2 style="font-size: 15px">Refund and Cancellation Policy</h2>
        <div style="padding: 10px; border: 1px dashed #333">
          <p>
            All the money you pay will be refunded to your Beneficiary
            address&nbsp;along with the loan. after your loan is disbursed, and
            the service will not be canceled
          </p>
        </div>
        <div style="display: flex; margin-top: 20px">
          <div style="flex: 1; position: relative; padding-bottom: 20px">
            <div style="font-size: 16px; font-weight: 600">
              FINANCIAL LIMITED
            </div>
            <div
              style="
                font-size: 17px;
                font-weight: 600;
                margin-top: 80px;
                text-align: center;
              "
            >
              signature authorization
            </div>
            <div
              style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 70%;
                z-index: 2;
              "
            >
              <img
                style="object-fit: contain; width: 80%"
                src="https://fe368.com/app-api/profile/upload/2023/05/18/111 (2)_20230518003357A193.png"
              />
            </div>
          </div>
          <div
            style="
              flex: 1;
              position: relative;
              padding-bottom: 20px;
              margin-left: 20px;
            "
          >
            <div style="font-size: 16px; font-weight: 600">Borrower</div>
            <div
              style="
                position: absolute;
                top: 30px;
                left: 0;
                width: 100%;
                height: calc(100% - 80px);
                z-index: 2;
              "
            >
              <img
                style="object-fit: contain; width: 100%; display: none"
                src="###signature###"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Decimal from "decimal.js";

export default {
  data() {
    return {
      period: 1,
      amount: 0,
      locale: "en",
      rate: 0,
    };
  },
  computed: {
    totalRate() {
      return new Decimal(this.rate).mul(100).mul(new Decimal(this.period));
    },
  },
  created() {
    window.scrollTo(0, 0);
    if (this.I18n.locale.indexOf("zh") != -1) {
      this.locale = "zh";
    }
    this.period = this.$route.params.period;
    this.amount = this.$route.params.amount;
    this.getLoanConfig();
  },
  methods: {
    navBack() {
      this.$router.go(-1);
    },
    async getLoanConfig() {
      const res = await this.$api.getLoanConfig();
      if (res.code == 200) {
        res.data.forEach((item) => {
          if (this.amount < item.max_amount && this.amount >= item.min_amount) {
            this.rate = item.interest_rate.filter(
              (item) => item.period == this.period
            )[0].rate;
          }
          if (this.amount == res.data[res.data.length - 1].max_amount) {
            this.rate = item.interest_rate.filter(
              (item) => item.period == this.period
            )[0].rate;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.agreement-container {
  .back {
    width: 30px;
    height: 15px;
  }
}
</style>